<div id="navigation" class="navigation-menu-mobile active">
  <!-- Navigation Menu-->
  <ul class="navigation-menu">
    @for (item of menu; track $index; let i = $index) {
      <li [class.has-submenu]="item.children && item.children.length"
        [class.submenu-dismissed]="dismissedMenuIndex === i" (mouseenter)="dismissedMenuIndex = null"
        menuAim
        routerLinkActive="active-parent"
        [hidden]="(!item.requireSuperAdminPermission && companyId === 1) || (item.requireAdminPermission && !userHasAdminPermission) || (item.requireSuperAdminPermission && !userHasSuperAdminPermission) || (item.restrictedWhileImpersonating && userHasSuperAdminPermission && userIsImpersonating)">
        @if ((item.link && !item.externalLink) || !item.link) {
          <a [routerLink]="item.link ? ['/admin' + item.link] : undefined"
            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: !item.children?.length }"
            (click)="onMenuToggled(i, item, 1);">
            <span>
              @if (getLucideIcon(item); as lucideName) {
                <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="nav-lucide"></i-lucide>
              } @else {
                <i [ngClass]="item.icon"></i>
              }
              {{ item.text }}
            </span>
          </a>
        }
        @if (item.link && item.externalLink) {
          <a [href]="item.link"  target="_blank"
            (click)="onMenuToggled(i, item, 1);">
            <span>
              @if (getLucideIcon(item); as lucideName) {
                <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="nav-lucide"></i-lucide>
              } @else {
                <i [ngClass]="item.icon"></i>
              }
              {{ item.text }}
            </span>
          </a>
        }
        @if (item.children) {
          <ul class="submenu" [ngClass]="{'open' : menuItemStatuses.get(i)}">
            @for (ch of item.children; track $index; let ii = $index) {
              <li class="header__item--parent"
                submenuFlyout
          [hidden]="ch.hide ||
            (ch.requireAdminPermission && !userHasAdminPermission) ||
            (ch.requireCallReportPermission && !allowMortgageCallReports) ||
            (ch.requireEnabledPricingPermission && !pricingEnabled) ||
            (ch.requireExternalCompanyEnabled && !externalCompanyEnabled) ||
            (ch.requireSuperAdminPermission && !userHasSuperAdminPermission) ||
            (ch.requiredEnabledLeadManagementPermission && !leadManagementEnabled) ||
            (ch.requireBroadcastManagerAccessPermission && !broadcastManagerEnabled) || 
            (ch.requireEnabledOcrPermission && !ocrEnabled) || 
            (ch.requireEnabledLosPermission && !losEnabled) || 
            (ch.requireEnabledLoanBeamPermission && !loanBeamEnabled) || 
            (ch.requireEnabledChannelsPermission && !areThereEnabledChannels) || 
            (ch.requireEnabledDialerPermission && !dialerEnabled) || 
            (ch.requireEnabledCampaignsPermission && !campaignsEnabled) ||
            (ch.requirePipelineMetricsPermission && !pipelineMetricsEnabled) ||
            (ch.requirePipelineWaterfallPermission && !pipelineWaterfallEnabled) ||
            (ch.requireUrlaValidationPermission && !urlaValidationEnabled) ||
            (ch.incompleteFeature && companyId !== 2)
            ">
                @if (!ch.externalLink) {
                  <a [routerLink]="getRouterLink(ch)" [class.has-submenu]="ch.children"
                    routerLinkActive="active" [routerLinkActiveOptions]="{ exact: !ch.children?.length }"
                    (click)="onMenuToggled(i + '.' + ii, ch, 2)">
                    @if (getSubmenuLucideIcon(ch); as lucideName) {
                      <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="submenu-lucide"></i-lucide>
                    } @else {
                      <i [ngClass]="ch.icon ? ch.icon : item.icon"></i>
                    }
                    {{ ch.text }}
                    @if (ch.children) {
                      <i class="fas fa-chevron-right float-right"></i>
                    }
                  </a>
                }
                @if (ch.externalLink) {
                  <a href="{{ch.link || ''}}" target="_blank">
                    @if (getSubmenuLucideIcon(ch); as lucideName) {
                      <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="submenu-lucide"></i-lucide>
                    } @else {
                      <i [ngClass]="ch.icon ? ch.icon : ch.icon"></i>
                    }
                    {{ ch.text }}
                  </a>
                }
                @if (ch.children) {
                  <ul class="submenu" [ngClass]="{'open' : menuItemStatuses.get(i + '.' + ii)}">
                    @for (sub of ch.children; track $index; let iii = $index) {
                      <li class="header__item--parent"
                        submenuFlyout
              [hidden]="(sub.requireAdminPermission && !userHasAdminPermission) || 
              (sub.requireEnabledBranchesPermission && !branchesEnabled) || 
              (sub.requireEnabledPricingPermission && !pricingEnabled) || 
              (sub.requireExternalCompanyEnabled && !externalCompanyEnabled) || 
              (sub.requireEnabledChannelsPermission && !areThereEnabledChannels) || 
              (sub.requireEnabledDialerPermission && !dialerEnabled) || 
              (sub.requireEnabledCampaignsPermission && !campaignsEnabled) ||
              (sub.requireUrlaValidationPermission && !urlaValidationEnabled)">
                        @if (!sub.externalLink) {
                          <a [routerLink]="getRouterLink(sub)" [class.has-submenu]="sub.children"
                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: !sub.children?.length }"
                            (click)="onMenuToggled(i + '.' + ii + '.' + iii, sub, 3)">
                            @if (getSubmenuLucideIcon(sub); as lucideName) {
                              <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="submenu-lucide"></i-lucide>
                            } @else {
                              <i [ngClass]="sub.icon ? sub.icon : item.icon"></i>
                            }
                            {{ sub.text }}
                            @if (sub.children) {
                              <i class="fas fa-chevron-right float-right"></i>
                            }
                          </a>
                        }
                        @if (sub.externalLink) {
                          <a href="{{sub.link || ''}}" target="_blank">
                            @if (getSubmenuLucideIcon(sub); as lucideName) {
                              <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="submenu-lucide"></i-lucide>
                            } @else {
                              <i [ngClass]="sub.icon ? sub.icon : item.icon"></i>
                            }
                            {{ sub.text }}
                          </a>
                        }
                        @if (sub.children) {
                          <ul class="submenu" [ngClass]="{'open' : menuItemStatuses.get(i + '.' + ii + '.' + iii)}">
                            @for (subSub of sub.children; track $index; let iiii = $index) {
                              <li class="header__item--parent"
                  [hidden]="(subSub.requireAdminPermission && !userHasAdminPermission) || 
                  (subSub.requireEnabledBranchesPermission && !branchesEnabled) || 
                  (subSub.requireEnabledPricingPermission && !pricingEnabled) || 
                  (subSub.requireExternalCompanyEnabled && !externalCompanyEnabled) || 
                  (subSub.requireEnabledChannelsPermission && !areThereEnabledChannels) || 
                  (subSub.requireEnabledDialerPermission && !dialerEnabled) || 
                  (subSub.requireEnabledCampaignsPermission && !campaignsEnabled) ||
                  (subSub.requireUrlaValidationPermission && !urlaValidationEnabled)">
                                @if (!subSub.externalLink) {
                                  <a [routerLink]="getRouterLink(subSub)"
                                    routerLinkActive="active"
                                    (click)="onMenuToggled(i + '.' + ii + '.' + iii + '.' + iiii, subSub, 4)">
                                    @if (getSubmenuLucideIcon(subSub); as lucideName) {
                                      <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="submenu-lucide"></i-lucide>
                                    } @else {
                                      <i [ngClass]="subSub.icon ? subSub.icon : item.icon"></i>
                                    }
                                    {{ subSub.text }}
                                  </a>
                                }
                                @if (subSub.externalLink) {
                                  <a href="{{subSub.link || ''}}" target="_blank">
                                    @if (getSubmenuLucideIcon(subSub); as lucideName) {
                                      <i-lucide [name]="lucideName" [size]="15" [strokeWidth]="1.75" class="submenu-lucide"></i-lucide>
                                    } @else {
                                      <i [ngClass]="subSub.icon ? subSub.icon : item.icon"></i>
                                    }
                                    {{ subSub.text }}
                                  </a>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </li>
                    }
                  </ul>
                }
              </li>
            } @empty {
              @if (item.id === 'RecentlyVisited') {
                <li class="text-muted text-center py-2 px-3" style="white-space: nowrap;">No recents</li>
              }
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>
